import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";

/**
 * Shared desk side-glance chrome — plan/45.
 * Header + scroll body; callers own facts + View more.
 */
export function DeskGlancePeekShell(props: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  /** Defaults to “Glance · read only”. */
  subtitle?: string;
  children: ReactNode;
}) {
  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <DialogContent
        className="fixed inset-y-0 right-0 left-auto top-0 z-50 flex h-dvh max-h-dvh w-[min(100%,22.5rem)] max-w-none translate-x-0 translate-y-0 flex-col gap-0 rounded-none border-0 border-l border-[var(--color-border)] p-0 shadow-[var(--shadow-float)]"
        aria-describedby={undefined}
      >
        <div className="flex shrink-0 items-start justify-between gap-2 border-b border-[var(--color-border)] px-4 py-3">
          <div className="min-w-0">
            <DialogTitle className="truncate text-base">{props.title}</DialogTitle>
            <DialogDescription className="mt-0.5 text-xs text-[var(--color-muted)]">
              {props.subtitle ?? "Glance · read only"}
            </DialogDescription>
          </div>
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="shrink-0"
            onClick={() => props.onOpenChange(false)}
          >
            Close
          </Button>
        </div>
        <div className="min-h-0 flex-1 overflow-auto px-4 py-4">
          {props.children}
        </div>
      </DialogContent>
    </Dialog>
  );
}
